import { useState } from 'react';

import { AxiosError } from 'axios';

import useAxios from 'hooks/api/useAxios';

export type Swap = {
    first_page: number;
    second_page: number;
};

type UsePageSwapReturn = {
    loading: boolean;
    success: boolean;
    error: false | AxiosError<unknown, unknown>;
    swapPages: (swap: Swap) => void;
};

export const usePageSwap = (): UsePageSwapReturn => {
    const [data, setData] = useState<Swap>();

    const [res, { rerun }] = useAxios(
        {
            url: `/api/builder/page/swap/`,
            method: 'PATCH',
            data: {
                ...data,
                insert: 'after',
            },
            skipRequest: () => true,
        },
        [data]
    );

    const loading = res.type === 'loading';
    const success = res.type === 'success';
    const error = res.type === 'error' && res.data;

    const swapPages = (swap: Swap): void => {
        setData(swap);
        rerun();
    };

    return { success, loading, error, swapPages };
};
